import { render, staticRenderFns } from "./DataInputFeatures.vue?vue&type=template&id=30fce47e&"
import script from "./DataInputFeatures.vue?vue&type=script&lang=js&"
export * from "./DataInputFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports